import { useState } from "react";

import { Plug } from "components/icons/generated";
import Markdown from "components/markdown/Markdown";
import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import PageInfoHeader from "ds/components/PageInfoHeader";
import useTypedContext from "hooks/useTypedContext";
import { RunContext } from "components/Run/Context";
import CardCollapsible from "ds/components/Card/Collapsible";

import styles from "./styles.module.css";

const PluginOutputs = () => {
  const { run } = useTypedContext(RunContext);
  const [collapsedPanels, setCollapsedPanels] = useState<boolean[]>(
    run.pluginLogs.map((_, i) => i > 0)
  );

  if (!run.pluginLogs || !run.pluginLogs.length) {
    return <EmptyState title="No plugin outputs found" icon={Plug} />;
  }

  return (
    <Box
      direction="column"
      grow="1"
      fullWidth
      style={{ position: "relative" }}
      id="pluginOutputsWrapper"
    >
      <PageInfoHeader title="Plugin Outputs" />
      <Box direction="column" gap="large" padding="medium" scrollable>
        {run.pluginLogs.map((log, index) => {
          return (
            <CardCollapsible
              title={log.pluginName}
              headerSuffix={<Timestamp timestamp={log.message.timestamp} variant="p-body3" />}
              ariaLevel={3}
              ariaLabel={`${log.pluginName} outputs`}
              key={log.pluginName}
              isCollapsed={collapsedPanels[index]}
              onToggle={() =>
                setCollapsedPanels((prev) => {
                  const newPanels = [...prev];
                  newPanels[index] = !newPanels[index];
                  return newPanels;
                })
              }
            >
              <Markdown
                markup={log.message.message}
                className={styles.pluginLogsMarkdown}
                openLinksInNewTab
              />
            </CardCollapsible>
          );
        })}
      </Box>
    </Box>
  );
};

export default PluginOutputs;
